export default __webpack_public_path__ + "ru.2ac2876e.svg";